import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '@app/services/auth.service';
import { select, Store } from '@ngrx/store';
import { getLoggedInContact } from '@app/store/app.reducers';
import * as fromApp from '@app/store/app.reducers';
import { Contact } from '@app/model/contact.model';
import { map } from 'rxjs/operators';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { ONLINE_TERMS_URL } from '@app/constants/application-constants';

@Injectable({
    providedIn: 'root'
})
export class LegalUseGuard  {

    constructor(
        private auth: AuthService,
        private store: Store<fromApp.AppState>,
        private router: Router,
        private notifier: NzNotificationService
    ) {
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree> | boolean | UrlTree {
        const url = ONLINE_TERMS_URL;
        if (!this.auth.isAuthenticated() || state.url === url) {
            // allow when not logged in
            return true;
        }

        return this.store.pipe(
            select(getLoggedInContact),
            map((contact: Contact) => {
                if (!!contact && !contact.portalTcAccepted) {
                    this.router.navigate(['/pages/online-terms-and-conditions']);
                    this.notifier.warning(
                        'Please accept the Online Terms & Conditions and Privacy Statement',
                        '');
                    return false;
                }

                return true;
            })
        );
    }

}
